(function ($) {
  'use strict';
  var trackedAnswers = [];

  var restApiUrl = window.ys.rest_url + 'tdf23/v1/';

  this.TDF2023.Contest = function () {
    /*
     * prizes
     */
    this.$prizes = $('.prizes');

    $(document).on('click', 'nav.rounds li', this.switchPrizes.bind(this));

    var round = 1;

    /*
     * countdown
     */
    if (window.ys && window.ys.tdf23) {
      if (window.ys.tdf23.countdown && window.ys.tdf23.countdown.start) {
        jQuery(document).ready(function () {
          if (
            typeof window.WLCCountdown === 'function' &&
            $('#countdown').length
          ) {
            var ct = new WLCCountdown('countdown');
            ct.$countdown.on('WLC:Countdown:finished', function () {
              window.location.reload(true);
            });

            ct.alwaysTriggerFinish = true;
            var dateParts = window.ys.tdf23.countdown.start.split(',');
            ct.start(
              dateParts[0],
              dateParts[1],
              dateParts[2],
              dateParts[3],
              dateParts[4],
              dateParts[5]
            );
            setTimeout(function () {
              if (ct.getRemainingTime() === 0) {
                window.location.reload(true);
              }
            }, 30000);
          }
        });
      }

      if (window.ys.tdf23.round) {
        round = window.ys.tdf23.round;
      }
    }

    /*
     * Quiz related
     */
    this.firedFbEvent = false;
    this.$quiz = $('#quiz');

    var params = window.location.search.substring(1).split('&');
    var uriParams = {};
    for (var i = 0; i < params.length; i++) {
      var param = params[i].split('=');
      uriParams[param[0]] = decodeURIComponent(param[1]);
    }

    if (uriParams.confirmationStatus === 'confirmed') {
      var popup = new WLCPopup(null, false);

      popup.setObject(this.$quiz.find('.validation-popup').html());
      popup.show();

      this.gaEvent('Confirm');
    }

    this.storageKey = 'tdf23-round-' + round;
    this.cookieTestSubmitted = window.ysStorage.Get(this.storageKey);

    if (this.cookieTestSubmitted) {
      this.$quiz.find('input.mail').val(this.cookieTestSubmitted);
      this.showScreen(4);
    }

    this.$questionWrap = this.$quiz.find('.question-wrapper');
    this.$questionWrap.data('active', 1);

    this.$questionImages = this.$quiz.find('.contest-questions-left .inside');

    if (this.$questionWrap.length > 0) {
      this.currentQuestion = 1;

      $(document).on(
        'click touchstart',
        '#quiz button.next-btn',
        this.next.bind(this)
      );
      $(document).on(
        'click touchstart',
        '#quiz button.back-btn',
        this.back.bind(this)
      );
      $(document).on(
        'click touchstart',
        '#quiz button#submit-contest',
        this.submit.bind(this)
      );
      $(document).on(
        'click touchstart',
        '#quiz button.submit-newsletter',
        this.newsletter.bind(this)
      );
      $(document).on('click touchstart', '#quiz .qm', this.help.bind(this));

      this.totalQuestions = this.$questionWrap.find('.question').length;
      this.$progress = this.$quiz.find('.progress');

      // Hooks when answer changes
      this.$quiz.on('TDF2023:answer:changed', this.renderProgress.bind(this));
      this.renderProgress();
    }

    new ImageStretch({
      default: [
        {
          selector: '#tv-area .image-holder',
        },
      ],
      watched: [
        {
          selector: '.contest-questions .inside',
        },
      ],
    });

    /**
     * Countdown event for reloading the page when it reaches 0
     */
    $('#countdown').on(
      'WLC:Countdown:finished',
      this.countdownFinished.bind(this)
    );

    $(document).on(
      'touchstart click',
      '.prize-details button',
      this.showPrizeDetail.bind(this)
    );

    this.$googleConnect = $('.complete-with-google');

    if (this.$googleConnect.length > 0) {
      this.initializeGoogleClient = function () {
        var t = this;
        window.gapi.client
          .init({
            apiKey: 'AIzaSyDrfBCYtFRANR4-sOu1iTh5dXpvGUoNT8w',
            discoveryDocs: [
              'https://people.googleapis.com/$discovery/rest?version=v1',
            ],
            clientId:
              '1048115401330-ee3m86vl41md7iesi53gfaahq2ubbcrf.apps.googleusercontent.com',
            scope: 'profile',
          })
          .then(
            function () {
              window.gapi.auth2
                .getAuthInstance()
                .isSignedIn.listen(t.updateSigninStatus.bind(t));
              $(document).on(
                'click touchstart',
                '.complete-with-google button',
                t.googleConnect.bind(t)
              );
              t.$googleConnect.addClass('show');
            },
            function (e) {
              console.log('GAPI Error:', e);
            }
          );
      };

      this.initializeGoogle = function () {
        if (typeof window.gapi !== 'undefined') {
          window.gapi.load(
            'client:auth2',
            this.initializeGoogleClient.bind(this)
          );
        }
      };

      var userAgent = window.navigator.userAgent.toLowerCase();
      if (/iphone|ipod|ipad|android/.test(userAgent) === false) {
        $.getScript(
          'https://apis.google.com/js/api.js',
          this.initializeGoogle.bind(this)
        );
      }
    }
  };

  this.TDF2023.Contest.prototype.switchPrizes = function (e) {
    var $button = $(e.currentTarget);
    var round = $button.data('round');
    if (round) {
      $button.addClass('active').siblings().removeClass('active');
      this.$prizes
        .find('.prize-details')
        .removeClass('shown')
        .find('.content')
        .slideUp();
      this.$prizes
        .removeClass('active-round-1 active-round-2 active-round-3')
        .addClass('active-round-' + round);
      // Manually reveal the images
      this.$prizes
        .find('> div:nth-of-type(' + round + ') img')
        .each(function () {
          $(document).trigger('LazyLoad:reveal', [this]);
        });
    }
  };

  this.TDF2023.Contest.prototype.countdownFinished = function () {
    window.location.reload(false);
  };

  this.TDF2023.Contest.prototype.help = function (e) {
    var qm = $(e.currentTarget);
    var question = qm.closest('.i').data('q');

    var popup = new WLCPopup(
      '<div class="question-help">' +
        '<div class="ico"><svg class="font-icon"><use href="#question-mark_circle" xlink:href="#question-mark_circle"></use></svg></div>' +
        '<div class="txt">' +
        this.$quiz
          .find('#' + question)
          .find('h2')
          .text() +
        '</div></div>',
      false
    );
    popup.show();
  };

  this.TDF2023.Contest.prototype.back = function (e) {
    var $button = $(e.currentTarget);
    var $question = $button.closest('.question');

    this.keepOnTop();

    var nextQuestion = $question.index();
    this.goToQuestion(nextQuestion);
  };

  this.TDF2023.Contest.prototype.next = function (e) {
    if (typeof fbq === 'function' && this.firedFbEvent === false) {
      fbq('track', 'td_contest');
      this.firedFbEvent = true;
    }

    var $button = $(e.currentTarget);
    if ($button.attr('type') !== 'submit') {
      e.preventDefault();
    }
    var $question = $button.closest('.question');

    if ($question.find('input:checked').length < 1) {
      $question.find('input').prop('checked', false).removeAttr('checked');
      $question.find('.select-answer').slideDown();
      return;
    }

    this.keepOnTop();

    $button.attr('disabled', true);
    $question.addClass('answered');
    var nextQuestion = $question.index() + 2;
    var answeredQuestionIndex = nextQuestion - 1;

    if (
      answeredQuestionIndex > 0 &&
      trackedAnswers.indexOf(answeredQuestionIndex) < 0
    ) {
      this.gaEvent('Answer', answeredQuestionIndex);
      trackedAnswers.push(answeredQuestionIndex);
    }

    //submit page
    if (this.goToQuestion(nextQuestion) === -1) {
      this.showScreen(2);
    }

    $button.removeAttr('disabled');
  };

  this.TDF2023.Contest.prototype.showScreen = function (id) {
    this.$quiz.find('.screen:not(.contest-countdown)').addClass('hidden');
    var $formTitle = this.$quiz.find('.form-header');

    switch (id) {
      case 1:
        this.$quiz.find('.contest-questions.screen').removeClass('hidden');
        $formTitle.removeClass('hidden');
        break;
      case 2:
        this.$quiz.find('.contest-submit-success.screen').removeClass('hidden');
        $formTitle.addClass('hidden');
        if (typeof fbq === 'function') {
          fbq('track', 'Lead');
        }
        break;
      case 3:
        this.$quiz.find('.contest-submit-fail.screen').removeClass('hidden');
        $formTitle.addClass('hidden');
        break;
      case 4:
        this.$quiz.find('.contest-submit-already.screen').removeClass('hidden');
        $formTitle.addClass('hidden');
        break;
    }
  };

  this.TDF2023.Contest.prototype.removeQuestionClass = function (
    index,
    className
  ) {
    return (className.match(/progress-\d+/g) || []).join(' ');
  };

  this.TDF2023.Contest.prototype.gaEvent = function (action, label) {
    /**
     * @see site/web/app/themes/skoda-wlc-theme/assets/scripts/init-js/init.js
     */
    if (window.dispatchEventType) {
      window.dispatchEventType(
        document,
        'SDrive:Track:Contest',
        undefined,
        undefined,
        undefined,
        {
          // Make sure the data are strings
          action: '' + action,
          label: label ? '' + label : undefined,
          name: 'Tour De France',
        }
      );
    }
  };

  /**
   * Go to selected question
   */
  this.TDF2023.Contest.prototype.goToQuestion = function (question) {
    if (!this.totalQuestions) {
      return 0;
    }

    if (!question || typeof question !== 'number') {
      question = this.currentQuestion + 1;
    }

    if (question > this.totalQuestions) {
      return -1;
    }

    this.$questionWrap
      .removeClass(this.removeQuestionClass)
      .addClass('progress-' + (question - 1));
    this.$questionWrap.data('active', question);

    this.$questionImages
      .removeClass(this.removeQuestionClass)
      .addClass('progress-' + question);
    $(document).trigger('LazyLoad:reveal', [
      $(this.$questionImages).find('img.q-' + question)[0],
    ]);

    this.currentQuestion = question;

    this.$quiz.trigger('TDF2023:answer:changed');
    return 1;
  };

  this.TDF2023.Contest.prototype.newsletter = function (e) {
    var t = this;
    var button = $(e.currentTarget);
    var screen = button.closest('.screen');
    var error = 0;

    screen.find('.error').slideUp(0);

    var email = screen.find('input.mail').val();
    if (!email) {
      screen.find('.empty-email').slideDown();
      error = 1;
    }

    var news = screen.find('input.news').is(':checked');
    if (!news) {
      screen.find('.agreement').slideDown();
      error = 1;
    }

    if (error) {
      return false;
    }

    button.addClass('loading').attr('disabled', true);

    $.ajax({
      method: 'POST',
      url: restApiUrl,
      data: {
        action: 'news',
        email: email,
      },
      dataType: 'json',
      success: function (resp) {
        var response = JSON.parse(resp);
        button.removeClass('loading').attr('disabled', false);

        if (response.error) {
          if (response.error === 'invalid-email') {
            screen.find('.invalid-email').slideDown();
            return false;
          }

          screen.find('.general').slideDown();
          return false;
        }

        //all ok, newsletter === 1
        var msg = t.$quiz.find('.check-news-msg-wrap').html();
        if (screen.find('.cs-bottom').length) {
          screen.find('.cs-bottom').html(msg);
        } else {
          screen.html(msg);
        }

        t.gaEvent('Opted-in', 'Newsletter');
      },
    });
  };

  this.TDF2023.Contest.prototype.submit = function (e) {
    var t = this;
    var button = $(e.currentTarget);
    var screen = button.closest('.screen');
    var error = 0;

    var selected = [];
    t.$quiz.find('.answer input:checked').each(function () {
      selected.push({
        q: $(this).data('n'),
        a: $(this).val(),
      });
    });

    screen.find('.error').slideUp(0);

    var email = screen.find('input.mail').val();
    if (!email) {
      screen.find('.empty-email').slideDown();
      error = 1;
    }

    if (error) {
      return false;
    }

    button.addClass('loading').attr('disabled', true);

    $.ajax({
      method: 'POST',
      url: restApiUrl + $('#contest-debug').val(),
      data: {
        action: 'contest',
        email: email,
        news: screen.find('input#news-ss').is(':checked') ? 1 : 0,
        terms: screen.find('input#terms-confirm').is(':checked') ? 1 : 0,
        questions: selected,
        lang: t.$quiz.find('#contest-lang').val(),
        page: t.$quiz.find('#contest-page').val(),
        round: t.$quiz.find('#contest-round').val(),
      },
      dataType: 'json',
      success: function (resp) {
        var response = JSON.parse(resp);
        t.$quiz.find('input.mail').val(email);
        button.removeClass('loading').attr('disabled', false);

        if (response.error) {
          if (response.error === 'invalid-email') {
            screen.find('.invalid-email').slideDown();
            return false;
          } else if (response.error === 'already-entered') {
            t.showScreen(4);
            return false;
          } else if (response.error === 'missing-terms') {
            screen.find('.missing-terms').slideDown();
            return false;
          }

          screen.find('.general').slideDown();
          return false;
        }

        if (response.newsletter === 1) {
          t.gaEvent('Opted-in', 'Newsletter');
        }

        if (response.contest === 1) {
          window.ysStorage.Set(t.storageKey, email, 'prefs');
          var $check = t.$quiz.find('.check-contest-msg-wrap');
          if (response.newsletter === 1) {
            $check.find('.cs-bottom').hide();
          } else {
            $check.find('.email').val(email);
          }
          screen.html($check.html());
          t.gaEvent('Pass');
        } else {
          if (response.newsletter === 1) {
            t.$quiz
              .find('.contest-submit-fail .cs-bottom')
              .html(t.$quiz.find('.check-news-msg-wrap').html());
          }

          if (response.bad) {
            $.each(response.bad, function (k, v) {
              $('.correct-w .i-' + v).addClass('show');
            });
          }

          t.showScreen(3);
          t.gaEvent('Fail');
        }
      },
      complete: function () {
        button.attr('disabled', false).removeClass('loading');
      },
      error: function () {
        screen.find('.general').slideDown();
      },
    });
  };

  /**
   * Scroll back to the top of the contest
   * @returns {*}
   */
  this.TDF2023.Contest.prototype.keepOnTop = function () {
    var topPosition = this.$quiz
      .find('.contest-questions .inside')
      .offset().top;
    var topOffset = topPosition - window.scrollY;
    if (this.$tdMenu && this.$tdMenu.is(':visible')) {
      topPosition -= this.$tdMenu.height();
    }

    if (topOffset < 0 && topPosition > 0) {
      $('html, body').animate(
        {
          scrollTop: topPosition,
        },
        300,
        'swing'
      );
    }
    return this;
  };

  /**
   * Show prize details
   * @returns {*}
   */
  this.TDF2023.Contest.prototype.showPrizeDetail = function (e) {
    var $button = $(e.currentTarget);
    if ($button.data('touched')) {
      return;
    }

    $button.data('touched', true);
    setTimeout(function () {
      $button.data('touched', null);
    }, 200);

    var $details = $button.closest('.prize-details');
    var $content = $details.find('.content');

    var desktop = $details.find('.helper').is(':visible');

    if (desktop) {
      var popup = new WLCPopup(
        '<div class="prize-details">' + $content.html() + '</div>',
        false
      );
      popup.show();
    } else {
      if ($details.hasClass('shown')) {
        $details.removeClass('shown');
        $content.slideUp();
      } else {
        $details.addClass('shown');
        $content.slideDown();
      }
    }
  };

  /**
   * Enable navigation through progress buttons
   */
  this.TDF2023.Contest.prototype.renderProgress = function () {
    var $progress = this.$progress;
    var $qw = this.$questionWrap;

    $progress.find('span').removeClass('active');

    $progress.find('span').each(function () {
      if (parseInt($(this).data('question')) <= parseInt($qw.data('active'))) {
        $(this).addClass('active');
      }
    });
  };

  /*
   * Google connect
   */

  /**
   * When user presses the connect with google button
   * @param e
   */
  this.TDF2023.Contest.prototype.googleConnect = function (e) {
    e.preventDefault();

    var $button = $(e.currentTarget);
    $button.addClass('loading');

    if (
      !this.updateSigninStatus(
        window.gapi.auth2.getAuthInstance().isSignedIn.get()
      )
    ) {
      $(e.currentTarget).attr('disabled', true);
      window.gapi.auth2.getAuthInstance().signIn();
    }
  };

  /**
   * Updates the sign in status if it changes
   * @param signedIn  Whether the user is signed in or not
   */
  this.TDF2023.Contest.prototype.updateSigninStatus = function (signedIn) {
    if (this.$googleConnect.length > 1) {
      this.$googleConnect.find('button').removeAttr('disabled');
    }

    if (!signedIn) {
      return false;
    }

    var t = this;

    // fill in the form
    gapi.client.people.people
      .get({
        resourceName: 'people/me',
        'requestMask.includeField':
          'person.names,person.emailAddresses,person.phoneNumbers',
      })
      .then(
        function (response) {
          if (!response.result) {
            console.log('GAPI SignIn Error: ', response);
            return;
          }

          t.$googleConnect.remove();
          var emails = response.result.emailAddresses
            ? response.result.emailAddresses
            : null;

          var arr = [];

          var emailsInput = t.$quiz.find('.mail');

          if (emails && emailsInput.length) {
            if (emails.length > 1) {
              arr = [];
              $.each(emails, function (index, el) {
                arr.push(el.value);
              });
              t.selectItem(arr, emailsInput);
            } else {
              emailsInput.val(emails[0].value);
            }
          }
        },
        function (reason) {
          console.log('GAPI SignIn Error: ' + reason);
        }
      );

    return true;
  };

  this.TDF2023.Contest.prototype.selectItem = function (items, $el) {
    var $form = $('<div class="select-option"></div>');
    $.each(items, function (index, item) {
      $form.append('<label class="option">' + item + '</label>');
    });

    var popup = new WLCPopup('', false);

    $form.find('.option').on('click touchstart', function () {
      popup.hide();
      $el.val($(this).html());
    });

    popup.setObject($form).show();
  };
}).bind(window)(jQuery);
